/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Activity } from '../model';
// @ts-ignore
import type { ActivitySuggestionList } from '../model';
// @ts-ignore
import type { Category } from '../model';
// @ts-ignore
import type { CategoryListResponse } from '../model';
// @ts-ignore
import type { ConfirmActivitiesSuggestedList } from '../model';
// @ts-ignore
import type { CreateActivityRequest } from '../model';
// @ts-ignore
import type { CreateActivityResponse } from '../model';
// @ts-ignore
import type { CreateCategoryResponse } from '../model';
// @ts-ignore
import type { LocalizedName } from '../model';
// @ts-ignore
import type { UpdateActivityRequest } from '../model';
// @ts-ignore
import type { UpdateActivityResponse } from '../model';
// @ts-ignore
import type { UpdateCategoryResponse } from '../model';
/**
 * CategoriesActivitiesApi - axios parameter creator
 */
export const CategoriesActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept or reject the activities suggested
         * @param {ConfirmActivitiesSuggestedList} confirmActivitiesSuggestedList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitySuggestionConfirmation: async (confirmActivitiesSuggestedList: ConfirmActivitiesSuggestedList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmActivitiesSuggestedList' is not null or undefined
            assertParamExists('activitySuggestionConfirmation', 'confirmActivitiesSuggestedList', confirmActivitiesSuggestedList)
            const localVarPath = `/admin/activities/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmActivitiesSuggestedList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a new activity
         * @param {CreateActivityRequest} createActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity: async (createActivityRequest: CreateActivityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createActivityRequest' is not null or undefined
            assertParamExists('createActivity', 'createActivityRequest', createActivityRequest)
            const localVarPath = `/admin/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createActivityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit a new category
         * @param {File} icon Category image file
         * @param {LocalizedName} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (icon: File, description: LocalizedName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'icon' is not null or undefined
            assertParamExists('createCategory', 'icon', icon)
            // verify required parameter 'description' is not null or undefined
            assertParamExists('createCategory', 'description', description)
            const localVarPath = `/admin/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (icon !== undefined) { 
                localVarFormParams.append('icon', icon as any);
            }

            if (description !== undefined) { 
                localVarFormParams.append('description', new Blob([JSON.stringify(description, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity: async (activityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('deleteActivity', 'activityId', activityId)
            const localVarPath = `/admin/activity/{activityId}`
                .replace('{activityId}', encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteCategory', 'categoryId', categoryId)
            const localVarPath = `/admin/category/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity: async (activityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('getActivity', 'activityId', activityId)
            const localVarPath = `/admin/activity/{activityId}`
                .replace('{activityId}', encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the Categories and activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesActivities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategory: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('getCategory', 'categoryId', categoryId)
            const localVarPath = `/admin/category/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the suggested activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedActivities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/activities/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update activity
         * @param {string} activityId 
         * @param {UpdateActivityRequest} updateActivityRequest Updated Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity: async (activityId: string, updateActivityRequest: UpdateActivityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('updateActivity', 'activityId', activityId)
            // verify required parameter 'updateActivityRequest' is not null or undefined
            assertParamExists('updateActivity', 'updateActivityRequest', updateActivityRequest)
            const localVarPath = `/admin/activity/{activityId}`
                .replace('{activityId}', encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateActivityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update category
         * @param {string} categoryId 
         * @param {File} [icon] Category image file
         * @param {LocalizedName} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory: async (categoryId: string, icon?: File, description?: LocalizedName, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('updateCategory', 'categoryId', categoryId)
            const localVarPath = `/admin/category/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (icon !== undefined) { 
                localVarFormParams.append('icon', icon as any);
            }

            if (description !== undefined) { 
                localVarFormParams.append('description', new Blob([JSON.stringify(description, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesActivitiesApi - functional programming interface
 */
export const CategoriesActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept or reject the activities suggested
         * @param {ConfirmActivitiesSuggestedList} confirmActivitiesSuggestedList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activitySuggestionConfirmation(confirmActivitiesSuggestedList: ConfirmActivitiesSuggestedList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activitySuggestionConfirmation(confirmActivitiesSuggestedList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.activitySuggestionConfirmation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit a new activity
         * @param {CreateActivityRequest} createActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivity(createActivityRequest: CreateActivityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivity(createActivityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.createActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit a new category
         * @param {File} icon Category image file
         * @param {LocalizedName} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(icon: File, description: LocalizedName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(icon, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.createCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete the activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivity(activityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivity(activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.deleteActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategory(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.deleteCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivity(activityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Activity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivity(activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.getActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all the Categories and activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesActivities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesActivities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.getCategoriesActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategory(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Category>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.getCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all the suggested activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestedActivities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivitySuggestionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestedActivities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.getSuggestedActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update activity
         * @param {string} activityId 
         * @param {UpdateActivityRequest} updateActivityRequest Updated Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActivity(activityId: string, updateActivityRequest: UpdateActivityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActivity(activityId, updateActivityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.updateActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update category
         * @param {string} categoryId 
         * @param {File} [icon] Category image file
         * @param {LocalizedName} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategory(categoryId: string, icon?: File, description?: LocalizedName, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(categoryId, icon, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoriesActivitiesApi.updateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoriesActivitiesApi - factory interface
 */
export const CategoriesActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesActivitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept or reject the activities suggested
         * @param {ConfirmActivitiesSuggestedList} confirmActivitiesSuggestedList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activitySuggestionConfirmation(confirmActivitiesSuggestedList: ConfirmActivitiesSuggestedList, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.activitySuggestionConfirmation(confirmActivitiesSuggestedList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a new activity
         * @param {CreateActivityRequest} createActivityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity(createActivityRequest: CreateActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateActivityResponse> {
            return localVarFp.createActivity(createActivityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit a new category
         * @param {File} icon Category image file
         * @param {LocalizedName} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(icon: File, description: LocalizedName, options?: RawAxiosRequestConfig): AxiosPromise<CreateCategoryResponse> {
            return localVarFp.createCategory(icon, description, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity(activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteActivity(activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the activity
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<Activity> {
            return localVarFp.getActivity(activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the Categories and activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesActivities(options?: RawAxiosRequestConfig): AxiosPromise<CategoryListResponse> {
            return localVarFp.getCategoriesActivities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Category> {
            return localVarFp.getCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the suggested activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedActivities(options?: RawAxiosRequestConfig): AxiosPromise<ActivitySuggestionList> {
            return localVarFp.getSuggestedActivities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update activity
         * @param {string} activityId 
         * @param {UpdateActivityRequest} updateActivityRequest Updated Category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(activityId: string, updateActivityRequest: UpdateActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateActivityResponse> {
            return localVarFp.updateActivity(activityId, updateActivityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update category
         * @param {string} categoryId 
         * @param {File} [icon] Category image file
         * @param {LocalizedName} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory(categoryId: string, icon?: File, description?: LocalizedName, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCategoryResponse> {
            return localVarFp.updateCategory(categoryId, icon, description, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoriesActivitiesApi - interface
 */
export interface CategoriesActivitiesApiInterface {
    /**
     * 
     * @summary Accept or reject the activities suggested
     * @param {ConfirmActivitiesSuggestedList} confirmActivitiesSuggestedList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activitySuggestionConfirmation(confirmActivitiesSuggestedList: ConfirmActivitiesSuggestedList, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Submit a new activity
     * @param {CreateActivityRequest} createActivityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createActivity(createActivityRequest: CreateActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateActivityResponse>;

    /**
     * 
     * @summary Submit a new category
     * @param {File} icon Category image file
     * @param {LocalizedName} description 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCategory(icon: File, description: LocalizedName, options?: RawAxiosRequestConfig): AxiosPromise<CreateCategoryResponse>;

    /**
     * 
     * @summary Delete the activity
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteActivity(activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a category
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary get the activity
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActivity(activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<Activity>;

    /**
     * 
     * @summary Get all the Categories and activities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCategoriesActivities(options?: RawAxiosRequestConfig): AxiosPromise<CategoryListResponse>;

    /**
     * 
     * @summary Get category
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Category>;

    /**
     * 
     * @summary Get all the suggested activities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuggestedActivities(options?: RawAxiosRequestConfig): AxiosPromise<ActivitySuggestionList>;

    /**
     * 
     * @summary Update activity
     * @param {string} activityId 
     * @param {UpdateActivityRequest} updateActivityRequest Updated Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateActivity(activityId: string, updateActivityRequest: UpdateActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateActivityResponse>;

    /**
     * 
     * @summary Update category
     * @param {string} categoryId 
     * @param {File} [icon] Category image file
     * @param {LocalizedName} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCategory(categoryId: string, icon?: File, description?: LocalizedName, options?: RawAxiosRequestConfig): AxiosPromise<UpdateCategoryResponse>;

}

/**
 * CategoriesActivitiesApi - object-oriented interface
 */
export class CategoriesActivitiesApi extends BaseAPI implements CategoriesActivitiesApiInterface {
    /**
     * 
     * @summary Accept or reject the activities suggested
     * @param {ConfirmActivitiesSuggestedList} confirmActivitiesSuggestedList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activitySuggestionConfirmation(confirmActivitiesSuggestedList: ConfirmActivitiesSuggestedList, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).activitySuggestionConfirmation(confirmActivitiesSuggestedList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit a new activity
     * @param {CreateActivityRequest} createActivityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createActivity(createActivityRequest: CreateActivityRequest, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).createActivity(createActivityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit a new category
     * @param {File} icon Category image file
     * @param {LocalizedName} description 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCategory(icon: File, description: LocalizedName, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).createCategory(icon, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the activity
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteActivity(activityId: string, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).deleteActivity(activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a category
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCategory(categoryId: string, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).deleteCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the activity
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getActivity(activityId: string, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).getActivity(activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the Categories and activities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCategoriesActivities(options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).getCategoriesActivities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get category
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCategory(categoryId: string, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).getCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the suggested activities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSuggestedActivities(options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).getSuggestedActivities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update activity
     * @param {string} activityId 
     * @param {UpdateActivityRequest} updateActivityRequest Updated Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateActivity(activityId: string, updateActivityRequest: UpdateActivityRequest, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).updateActivity(activityId, updateActivityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update category
     * @param {string} categoryId 
     * @param {File} [icon] Category image file
     * @param {LocalizedName} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCategory(categoryId: string, icon?: File, description?: LocalizedName, options?: RawAxiosRequestConfig) {
        return CategoriesActivitiesApiFp(this.configuration).updateCategory(categoryId, icon, description, options).then((request) => request(this.axios, this.basePath));
    }
}

